import React, {useContext} from 'react';
import IconButton from '@mui/material/IconButton';
import {useTheme} from '@mui/material/styles';
import {Box, Grid, Slide, useMediaQuery, useScrollTrigger} from "@mui/material";
import {useNavigate} from "react-router-dom";
import MovieFilterOutlinedIcon from "@mui/icons-material/MovieFilterOutlined";
import {ThemeModeContext} from "../Providers/Theme/Theme";
import {DarkMode, LightMode} from "@mui/icons-material";
import {GitHubIcon} from "../Icons/GitHubIcon";

type TopBarProps = {
  title?: string,
  disableGutters?: boolean
}

const TopBar: React.FC<TopBarProps> = ({title, disableGutters}) => {
  const theme = useTheme();
  const {mode, setMode} = useContext(ThemeModeContext);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("xl"))
  const navigate = useNavigate();

  const trigger = useScrollTrigger(
    {
      disableHysteresis: true,
      threshold: 20,
    }
  );

  const handleThemeChange = () => {
    setMode(mode === 'light' ? 'dark' : 'light')
  }

  return (
    <>
      <Slide
        in={!trigger}
        direction="down"
        style={{transitionDuration: '200ms'}}
      >
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          py={isLargeScreen ? 2 : 1}
          px={isLargeScreen ? 4 : 2}
          sx={{
            position: 'fixed',
            top: 0,
            right: 0,
            width: '100%',
            borderBottom: 'solid 1px',
            bgcolor: theme => theme.palette.background.default,
            zIndex: theme => theme.zIndex.appBar,
          }}
        >
          <Grid xs="auto" item container justifyContent="flex-start" alignItems="center">
            <Grid item alignItems="center" container>
              <IconButton size="small" onClick={() => {
                navigate('/');
              }}>
                <MovieFilterOutlinedIcon sx={{color: theme.palette.text.primary}}
                                         fontSize={isMobile ? 'medium' : 'large'}/>
              </IconButton>
            </Grid>
          </Grid>
          <Grid xs="auto" item container justifyContent="flex-end" alignItems="center" spacing={2}>
            <Grid item>
              <IconButton
                color="inherit"
                onClick={handleThemeChange}
              >
                {mode === 'light' ? <DarkMode/> : <LightMode/>}
              </IconButton>
            </Grid>
            <Grid item>
              <IconButton
                onClick={() => {
                  window.open('https://github.com/MarcoNapoleone/rumors', '_blank');
                }}
              >
                <GitHubIcon fill={theme.palette.text.primary}/>
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
      </Slide>
      {disableGutters
        && <Box sx={{mb: 10}}/>}
    </>
  );
};


export default TopBar;